import React from 'react'
import MaterialSymbol from '../material-symbol'

const DeleteOutline = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="delete_outline" {...props} />
))

DeleteOutline.displayName = 'DeleteOutline'

export default DeleteOutline
